export type Fingerprint = {
    visitorId: string;
    requestId: string;
};

let currentFingerprint: Fingerprint | null = null;

let resolveReady: (fp: Fingerprint) => void;
let rejectReady: (err: unknown) => void;
let readyPromise: Promise<Fingerprint> = new Promise<Fingerprint>(
    (resolve, reject) => {
        resolveReady = resolve;
        rejectReady = reject;
    },
);
let isSettled = false;

export const setFingerprint = (fp: Fingerprint): void => {
    currentFingerprint = fp;
    if (!isSettled) {
        isSettled = true;
        resolveReady(fp);
    }
};

export const failFingerprint = (err: unknown): void => {
    if (!isSettled) {
        isSettled = true;
        rejectReady(err);
    }
};

export const getFingerprintSync = (): Fingerprint | null => currentFingerprint;

export const awaitFingerprint = async (
    timeoutMs = 1500,
): Promise<Fingerprint | null> => {
    if (currentFingerprint) return currentFingerprint;
    try {
        return await Promise.race<Fingerprint | null>([
            readyPromise,
            new Promise<null>((resolve) =>
                setTimeout(() => resolve(null), timeoutMs),
            ),
        ]);
    } catch {
        return null;
    }
};
